import { on } from '@ember/modifier';
import Component from '@glimmer/component';

import CommonUiIconComponent from 'webapp/components/common/ui-icon';

import type { AnyFilterSort } from 'webapp/models-custom/filter-sort/base';

interface Args {
	title: string;
	addNewItem: () => void;
	model?: AnyFilterSort;
}

export default class TableAddNewItemComponent extends Component<Args> {
	get isVisible(): boolean {
		return !this.args.model?.noResults;
	}
	<template>
		{{#if this.isVisible}}
			<div class="add-new-item">
				<a class="wrapper" {{on "click" @addNewItem}}>
					<div class="circle">
						<CommonUiIconComponent @name="Plus" @size="md" />
					</div>
					<div class="title">{{@title}}</div>
				</a>
			</div>
		{{/if}}
	</template>
}
